let checkIsMobile = function () {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  let width = document.documentElement.clientWidth;
  return !!(flag || width <= 500)
}

function urlQuery(e) {
  const t = window.location.search.match(new RegExp("(\\?|&)" + e + "=([^&]*)(&|$)"));
  return t ? decodeURIComponent(t[2]) : ""
}

export {
  urlQuery,
  checkIsMobile
}